import { Input } from "@/components/ui/input";

const ServerUrlInput = ({
  serverUrl,
  onUrlChange,
  disabled = false,
}: {
  serverUrl: string;
  onUrlChange: (url: string) => void;
  disabled?: boolean;
}) => (
  <Input
    className="w-full"
    value={serverUrl}
    placeholder="https://mcp.example.com/promptlayer"
    onChange={e => onUrlChange(e.target.value)}
    disabled={disabled}
  />
);
export default ServerUrlInput;
